import { Button } from "./ui/button";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { VideoModal } from "./VideoModal";
import { EnrollmentModal } from "./EnrollmentModal";
import { useState } from 'react';
import heroimg from './../styles/hero_banner.jpg';

export function Hero() {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isEnrollmentModalOpen, setIsEnrollmentModalOpen] = useState(false);
  return (
    <section className="bg-gradient-to-br from-blue-50 to-purple-50 py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-medium">
                Learning Adventure
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-800 leading-tight">
              Welcome to
              <span className="block text-orange-400">Eyes Montessori London Kains</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed max-w-md">
              Discover a world of interactive learning designed specifically for children. 
              Our engaging programs foster creativity, curiosity, and confidence.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                className="bg-orange-400 hover:bg-orange-500 text-white px-8 py-3 rounded-full text-lg"
                onClick={() => setIsEnrollmentModalOpen(true)}
              >
                Start Learning
              </Button>
              <Button 
                variant="outline" 
                className="border-2 border-orange-400 text-orange-400 hover:bg-orange-50 px-8 py-3 rounded-full text-lg"
                onClick={() => setIsVideoModalOpen(true)}
              >
                Watch Demo
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative z-10">
              <ImageWithFallback
                src={heroimg}
                alt="Happy child learning"
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute top-4 right-4 w-20 h-20 bg-yellow-300 rounded-full opacity-80"></div>
            <div className="absolute bottom-8 left-4 w-16 h-16 bg-pink-300 rounded-full opacity-70"></div>
            <div className="absolute top-1/2 -left-8 w-12 h-12 bg-blue-300 rounded-full opacity-60"></div>
          </div>
        </div>
      </div>
      
      <VideoModal 
        isOpen={isVideoModalOpen} 
        onClose={() => setIsVideoModalOpen(false)} 
      />
      
      <EnrollmentModal 
        isOpen={isEnrollmentModalOpen} 
        onClose={() => setIsEnrollmentModalOpen(false)} 
      />
    </section>
  );
}